export enum DATA_RESPONSE_TYPE {
	// TEXT = 'TEXT',
	NUMBER = 'NUMBER',
	NUMBER_WITH_TEXT_ALIASES = 'NUMBER_WITH_TEXT_ALIASES',
	BOOLEAN = 'BOOLEAN',
	// SINGLE_CHOICE = 'SINGLE_CHOICE',
	// MULTI_CHOICE = 'MULTI_CHOICE'
}